import { render, staticRenderFns } from "./PartBox.vue?vue&type=template&id=c36ba1ba&lang=pug&"
import script from "./PartBox.vue?vue&type=script&lang=ts&"
export * from "./PartBox.vue?vue&type=script&lang=ts&"
import style0 from "./PartBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports